import { useId } from "react";
import { useTranslation } from "react-i18next";

export const DontShowAgainCheckbox = () => {
    const id = useId();
    const { t } = useTranslation();
    return (
        <div>
            <input id={id} name="dontShowAgain" className="checkbox" type="checkbox" />
            <label htmlFor={id}>{t("searchAssist.dontShowAgain")}</label>
        </div>
    );
};
